import cx from 'classnames';

import styles from './h2.module.scss';

export interface H2Props {
  className?: string;
  color?: string;
  children?: React.ReactElement;
  value?: string | number | undefined;
}

export const H2 = (props: H2Props) => {
  const { className = '', color = '', children, value } = props;

  return (
    <h2 className={cx(styles['h2'], color && styles[color], className)}>
      {children}
      {value && value}
    </h2>
  );
};

export default H2;
